import { render, staticRenderFns } from "./updatePasswordForm.vue?vue&type=template&id=0504615a"
import script from "./updatePasswordForm.vue?vue&type=script&lang=js"
export * from "./updatePasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports